import React from 'react';
import WidgetCustomization from '../WidgetCustomization';

const WidgetPage: React.FC = () => <WidgetCustomization />;

export default WidgetPage;
